/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.0.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../../reducers/rootReducer';
import { ILabelEditorReducerState } from './labelEditorReducer';
import { EEditableLabel, IEditableLabel } from './labelEditorTypes';

const makeSelectorLabelEditorState = (state: IRootReducer): ILabelEditorReducerState => state.labelEditor;

export const makeSelectorLabelEditorIsLoading = (): OutputSelector<IRootReducer, boolean,
    (state: ILabelEditorReducerState) => boolean> =>
    createSelector(
        makeSelectorLabelEditorState,
        (state: ILabelEditorReducerState) => state.isLoading,
    );

export const makeSelectorLabelEditorLabels = (): OutputSelector<IRootReducer, IEditableLabel[],
    (state: ILabelEditorReducerState) => IEditableLabel[]> =>
    createSelector(
        makeSelectorLabelEditorState,
        (state: ILabelEditorReducerState) => state.labels,
    );

export const makeSelectorLabelEditorSearchValue = (): OutputSelector<IRootReducer, string,
    (state: ILabelEditorReducerState) => string> =>
    createSelector(
        makeSelectorLabelEditorState,
        (state: ILabelEditorReducerState) => state.searchValue,
    );

export const makeSelectorLabelEditorType = (): OutputSelector<IRootReducer, EEditableLabel,
    (state: ILabelEditorReducerState) =>  EEditableLabel> =>
    createSelector(
        makeSelectorLabelEditorState,
        (state: ILabelEditorReducerState) => state.type,
    );
